import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeSeriesSort'
})
export class TimeSeriesSortPipe implements PipeTransform {

    doSort(sortResult: boolean, sortDirection: boolean) : number{
        if (sortResult && sortDirection) return 1;
        if (sortResult && !sortDirection) return -1;
        if (!sortResult && sortDirection) return -1;
        if (!sortResult && !sortDirection) return 1;
        return 0;
    }

    calcSort(a: any, b: any, desc: boolean) : number {
        var res = -1;
        if (desc) res = 1;
        //if (a == null && b == null) return 0;
        if (a == null) a = '';
        if (b == null) b = '';
        if (isNaN(a)){
            if (a < b) return res;
            if (a > b) return -res;
        }
        if (a.toLowerCase() < b.toLowerCase()) return res;
        if (a.toLowerCase() > b.toLowerCase()) return -res;
        return 0;
    }

    transform(items: any[], sortColumn: string, sortDirection: boolean): any {
        
        if (!items || sortColumn == null) {
            return items;
        } 
        
        if (sortColumn == "name"){
            //return items.sort((a,b) => this.doSort(a.name && b.name && a.name.toLowerCase() < b.name.toLowerCase(), sortDirection));
            return items.sort((a,b) => this.calcSort(a.name, b.name, sortDirection));
        }        
        if (sortColumn == "description"){
            //return items.sort((a,b) => this.doSort(a.name && b.name && a.name.toLowerCase() < b.name.toLowerCase(), sortDirection));
            return items.sort((a,b) => this.calcSort(a.description, b.description, sortDirection));
        }
        if (sortColumn == "source"){
            //return items.sort((a,b) => this.doSort(a.lastEventTime && b.lastEventTime && a.lastEventTime < b.lastEventTime, sortDirection));
            return items.sort((a,b) => this.calcSort(a.source, b.source, sortDirection));
        }
        if (sortColumn == "type"){
            //return items.sort((a,b) => this.doSort(a.lastDataTime && b.lastDataTime && a.lastDataTime < b.lastDataTime, sortDirection));
            return items.sort((a,b) => this.calcSort(a.type, b.type, sortDirection));
        }
        if (sortColumn == "siteType"){
            return items.sort((a,b) => this.calcSort(a.siteType, b.siteType, sortDirection));
            //return items.sort((a,b) => this.doSort(a.nextEventTime && b.nextEventTime && a.nextEventTime < b.nextEventTime, sortDirection));
        }
        if (sortColumn == "latest"){
            return items.sort((a,b) => this.calcSort(a.latestValue, b.latestValue, sortDirection));
            //return items.sort((a,b) => this.doSort(a.nextEventTime && b.nextEventTime && a.nextEventTime < b.nextEventTime, sortDirection));
        }
    }
}
